import { axios as apiService } from '../../service/axiosService';
import { BASE_URL, getIntergrationOverview } from '@service/apis';
import alert from '@components/alert';
import {
  addCommentAnchorRecord,
  addCommentScrollRecord,
  CommentActionType,
  // CommentAnchorKey,
  // directUser,
  dispatchAnchorCheckEvent,
} from '@components/directUser/index';
import store from '../../flux/store';
import actions from '@flux/action';
import {
  ANALYSIS_SUB_PERMISSIONS,
  DEFALUT_PERMISSION_SECTION,
  INTEGRATION_TYPES,
  // exchangeKeyVinInsightSegDrop,
  // exchangeKeyVInSegments,
  // exchangeDefaultModule,
  SEGMENTS,
} from '@model';
import { setSessionStorage, getSessionStorage } from '@utils/windowUtil';
import { formatCLink } from '../../container/appSiderBar/helper';

// the following members should implement by developer

export const shouldScrollInToView = (anchorRecord, anchorId) =>
  anchorRecord?.componentName === anchorId ||
  anchorRecord?.identifier === anchorId;

const anchorIdReg = /anchorId\[.*\]/g;

const goToAnalysisOrInsightsModule = (componentName, isInsights) =>
  async function (history, { projectId } = {}) {
    // const projectName = getSessionStorage('projectName');
    if (!projectId) {
      console.error('missing required argument: projectId');
      return;
    }
    try {
      const currentId = getSessionStorage('currentId');
      if (currentId !== projectId) {
        const res = await getIntergrationOverview(projectId);
        if (res?.projectInfo?.projectName) {
          setSessionStorage('currentId', projectId);
          setSessionStorage('projectName', res?.projectInfo?.projectName);
          store.dispatch(actions.changeCurrentId(projectId));
          // store.dispatch(action.matchBreadCrumb("projectName"));
        } else {
          // console.error(
          //   `Can't find correspond project information: ${projectId}`,
          // );
        }
      }

      history.replace(
        `/${
          isInsights ? 'insights' : 'analysis'
        }/${componentName}?projectId=${projectId}`,
        {
          menuId: componentName,
        },
      );
    } catch (e) {
      console.log(e);
    }
  };

export const urlMapOrigin = {
  'Project Home': {
    key: 'project-detail',
    jump: (history, { projectId } = {}) => {
      if (!projectId) {
        console.error('missing required argument: projectId');
        return;
      }
      const currentId = getSessionStorage('currentId');
      if (currentId !== projectId) {
        setSessionStorage('currentId', projectId);
        store.dispatch(actions.changeCurrentId(projectId));
      }
      history.push(`/project-detail/${projectId}`);
    },
  },
  'Company Overview': {
    key: 'analysis/companyoverview',
    menuId: 'companyoverview',
    jump: goToAnalysisOrInsightsModule('companyoverview'),
  },
  Financials: {
    key: 'analysis/financials',
    menuId: 'financials',
    jump: goToAnalysisOrInsightsModule('financials'),
  },
  'Go-To-Market': {
    key: 'analysis/gotomarket',
    menuId: 'gotomarket',
    jump: goToAnalysisOrInsightsModule('gotomarket'),
  },
  'Operational Footprint': {
    key: 'analysis/operationalfootprint',
    menuId: 'operationalfootprint',
    jump: goToAnalysisOrInsightsModule('operationalfootprint'),
  },
  'Sentiment Analysis': {
    key: 'analysis/sentimentanalysis',
    menuId: 'sentimentanalysis',
    jump: goToAnalysisOrInsightsModule('sentimentanalysis'),
  },
  ESG: {
    key: 'analysis/esgAndCsr',
    menuId: 'esgAndCsr',
    jump: goToAnalysisOrInsightsModule('esgAndCsr'),
  },
  'Integration Approach': {
    key: 'analysis/integration-approach',
    menuId: 'integration-approach',
    jump: goToAnalysisOrInsightsModule('integration-approach', true),
  },
  'Separation Approach': {
    key: 'analysis/separation-approach',
    menuId: 'separation-approach',
    jump: goToAnalysisOrInsightsModule('separation-approach', true),
  },
  'Value Drivers': {
    key: 'insights/value-driver',
    menuId: 'value-driver',
    jump: goToAnalysisOrInsightsModule('value-driver', true),
  },
  'Maturity Assessment': {
    key: 'insights/maturityAssessment',
    menuId: 'maturityAssessment',
    jump: goToAnalysisOrInsightsModule('maturityAssessment', true),
  },
  // customized project instance only have one guiding principle module
  'Guiding Principles': {
    key: 'insights/guidingPrinciples',
    menuId: 'guidingPrinciples',
    jump: goToAnalysisOrInsightsModule('guidingPrinciples', true),
  },
  'Integration Guiding Principles': {
    key: 'insights/guidingPrinciples',
    menuId: 'guidingPrinciples',
    jump: goToAnalysisOrInsightsModule('guidingPrinciples', true),
  },
  'Divestiture Guiding Principles': {
    key: 'insights/guidingPrinciples-divestitures',
    jump: goToAnalysisOrInsightsModule('guidingPrinciples-divestitures', true),
  },
  'Deal Rationale': {
    key: 'insights/dealrationale',
    menuId: 'dealrationale',
    jump: goToAnalysisOrInsightsModule('dealrationale', true),
  },
  'Governance Structure': {
    key: 'insights/OrgChart',
    menuId: 'OrgChart',
    jump: goToAnalysisOrInsightsModule('OrgChart', true),
  },
  'Deal Timeline': {
    key: 'insights/GanttChart',
    menuId: 'GanttChart',
    jump: goToAnalysisOrInsightsModule('GanttChart', true),
  },
};
export const urlMap = new Proxy(urlMapOrigin, {
  get(target, prop, receiver) {
    if (prop in target) {
      return target[prop];
    }
    const customizedModules =
      store.getState().projects?.customizedModules || [];
    const extraModule = customizedModules.find(
      (i) => i.module === prop && i.type !== 'default',
    );
    if (
      [
        'powerbiModule',
        'regular',
        'textContainer',
        'widget',
        'multiSection',
        INTEGRATION_TYPES.M365,
      ].includes(extraModule?.type)
    ) {
      const typeToKey = {
        powerbiModule: 'powerBI',
        regular: 'link/',
        textContainer: 'textContainer',
        widget: 'widgetLink',
        multiSection: 'multiSectionLink',
        [INTEGRATION_TYPES.M365]: INTEGRATION_TYPES.M365,
      };
      return {
        key: typeToKey[extraModule.type],
        jump: (history) => {
          history.push(
            `/${formatCLink(
              extraModule.type,
              extraModule.value,
              extraModule.module,
              extraModule.spnId,
              true,
              extraModule.link,
            )}`,
          );
        },
      };
    }
  },
});

// generate urlMap by customized modules data
export const getUrlMap = (moduleList) => {
  const result = {
    'Project Home': {
      key: 'project-detail',
      jump: (history, { projectId } = {}) => {
        if (!projectId) {
          console.error('missing required argument: projectId');
          return;
        }
        const currentId = getSessionStorage('currentId');
        if (currentId !== projectId) {
          setSessionStorage('currentId', projectId);
          store.dispatch(actions.changeCurrentId(projectId));
        }
        history.push(`/project-detail/${projectId}`);
      },
    },
  };
  moduleList.forEach((moduleItem) => {
    // process insight and analysis
    if (
      [
        DEFALUT_PERMISSION_SECTION.ANALYSIS,
        DEFALUT_PERMISSION_SECTION.INSIGHT,
      ].includes(moduleItem.value) &&
      moduleItem.originPermissions?.length
    ) {
      const segmentPath = {
        [DEFALUT_PERMISSION_SECTION.ANALYSIS]:
          DEFALUT_PERMISSION_SECTION.ANALYSIS,
        [DEFALUT_PERMISSION_SECTION.INSIGHT]: 'insights',
      };
      moduleItem.originPermissions.forEach((i) => {
        result[i.label] = {
          key: `${segmentPath[moduleItem.value]}/${i.value}`,
          menuId: i.value,
          jump: goToAnalysisOrInsightsModule(
            i.value,
            moduleItem.value === DEFALUT_PERMISSION_SECTION.INSIGHT,
          ),
        };
      });
    }
    // process customized module
    if (
      [
        'powerbiModule',
        'regular',
        'textContainer',
        'widget',
        'multiSection',
        INTEGRATION_TYPES.M365,
      ].includes(moduleItem?.type) &&
      moduleItem?.display
    ) {
      result[moduleItem.module] = {
        key: moduleItem.value,
        jump: (history) =>
          history.push(
            `/${formatCLink(
              moduleItem.type,
              moduleItem.value,
              moduleItem.module,
              moduleItem.spnId,
              true,
              moduleItem.link,
            )}`,
          ),
      };
    }
  });

  return result;
};

// const identifiers = {
//   ...exchangeDefaultModule,
//   ...exchangeKeyVInSegments,
//   ...exchangeKeyVinInsightSegDrop,
// };

export const urlTabMap = {
  ...Object.keys(urlMap).reduce(
    (acc, e) =>
      Object.assign(acc, {
        [urlMap[e].key]: {
          // identifier: identifiers[e],
          // filter: (elem) => elem.module === e,
          showModuleInTag: false,
          moduleName: e,
        },
      }),
    {},
  ),
  '/insights/insights': {
    filter: (e) => Object.values(SEGMENTS).includes(e.module),
    showModuleInTag: true,
    moduleName: 'Insights',
    // identifier: identifiers.Insights,
    shouldHideAdd: true,
  },
};

export const getUrlTabMap = (urlMapData = {}) => {
  const result = {
    ...Object.keys(urlMapData).reduce(
      (acc, e) =>
        Object.assign(acc, {
          [urlMapData[e].key]: {
            // identifier: identifiers[e],
            // filter: (elem) => elem.module === e,
            showModuleInTag: false,
            moduleName: e,
          },
        }),
      {},
    ),
  };
  const allAnalysisSubmoduleName = Object.entries(urlMapData)
    .map((i) => {
      const [name, { menuId }] = i;
      if (menuId && ANALYSIS_SUB_PERMISSIONS.hasOwnProperty(menuId)) {
        return name;
      }
      return null;
    })
    .filter((i) => i);
  if (result['insights/insights']) {
    result['insights/insights'].filter = (e) =>
      Object.values(allAnalysisSubmoduleName).includes(e.module);
  }
  return result;
};

function isModuleValueMatch(history, targetInfo) {
  const search = new URLSearchParams(history.location.search);
  const moduleValue = search.get('moduleValue');

  return moduleValue === targetInfo.identifier;
}

export const checkUserOnSamePage = (history, targetInfo, targetModule) => {
  const { location } = history;
  const pathname = location.pathname;
  const { projectId } = targetInfo;
  const currentProjectId = getSessionStorage('currentId');
  const isCustomizedModule = [
    'powerBI',
    'link',
    'textContainer',
    'widgetLink',
    INTEGRATION_TYPES.M365,
  ].some((i) => targetModule.key?.includes(i));
  const pathnameMatch = isCustomizedModule
    ? isModuleValueMatch(history, targetInfo)
    : pathname.includes(targetModule?.key);
  return pathnameMatch && projectId === currentProjectId;
};

// the key of urlMap
// export const CommentModuleKey = {
//   'Project Home': 'Project Home',
//   'Company Overview': 'Company Overview',
//   Financials: 'Financials',
//   'Go-To-Market': 'Go-To-Market',
//   'Operational Footprint': 'Operational Footprint',
//   'Sentiment Analysis': 'Sentiment Analysis',
//   ESG: 'ESG',
// };

export const findAnalysisModuleKey = (selectedMenu) =>
  Object.keys(CommentModuleKey).find((i) => i.includes(selectedMenu));

// use in notification center
// const ProjectHomeComponentName = {
//   complexity: 'Deal Complexity',
//   navigator: 'Accelerating the Transition',
//   lifecycle: 'M&A Lifecycle - Integration',
//   lifecycleDivestitures: 'M&A Lifecycle - Divestiture',
// };

export function alertModuleIsHidden(hiddenName) {
  const placeholder = 'module or component';
  alert.warning({
    content: `The ${
      hiddenName || placeholder
    } has been hidden, please unhide it and check the details.`,
  });
}

export const beforeJump = async (modulePathKey, targetInfo) => {
  const { projectId, componentName, identifier } = targetInfo;
  if (!projectId) {
    return false;
  }
  if (!checkCommentResolvedStatus(targetInfo)) {
    return false;
  }
  try {
    const accessibleModule = await apiService.get(
      `${BASE_URL}/project/accessibleModule/${projectId}`,
    );
    if (accessibleModule) {
      const { moduleList, homepageSectionList } = accessibleModule;
      if (moduleList.includes('Home')) {
        moduleList.push('project-detail');
      } // Home equals project-detail

      if (modulePathKey === 'project-detail' && (componentName || identifier)) {
        const componentAnchorId = identifier || componentName; // custom anchor id only exist on report builder
        const visible = homepageSectionList.some(
          (i) => componentAnchorId === i,
        );
        if (!visible) {
          alertModuleIsHidden(componentName.replace(anchorIdReg, '').trim());
        }
        return visible;
      }

      const moduleKeyFragment = modulePathKey.split('/')[1];
      if (
        moduleList.includes(modulePathKey) ||
        moduleList.some((i) => moduleKeyFragment === i)
      ) {
        return true;
      }
      alertModuleIsHidden(componentName);
      return false;
    }
  } catch (e) {
    console.log(e);
  }
  return false;
};

export const beforeJumpOnCommentTag = async (modulePathKey, targetInfo) => {
  if (!checkCommentResolvedStatus(targetInfo)) {
    return false;
  }
  return true;
};

// the following pages don't have SectionComment component for their page level comment
// const moduleWithoutPageLevelComment = [
//   CommentModuleKey['Project Home'],
//   CommentModuleKey['Company Overview'],
//   CommentModuleKey.Financials,
//   CommentModuleKey['Go-To-Market'],
//   CommentModuleKey['Operational Footprint'],
// ];
const moduleKeysWithoutPageLevelComment = [
  DEFALUT_PERMISSION_SECTION.HOME,
  ANALYSIS_SUB_PERMISSIONS.companyoverview,
  ANALYSIS_SUB_PERMISSIONS.financials,
  ANALYSIS_SUB_PERMISSIONS.gotomarket,
  ANALYSIS_SUB_PERMISSIONS.operationalfootprint,
];
export function checkCommentResolvedStatus(targetInfo) {
  const { moduleName, channelStatus, componentName } = targetInfo;
  let shouldJump = true;
  // comment resolved
  if (channelStatus) {
    shouldJump = false;
    addCommentAnchorRecord({
      ...targetInfo,
      actionType: CommentActionType.OpenCommentCenter,
    });
    addCommentScrollRecord({
      ...targetInfo,
      actionType: CommentActionType.CommentScrollIntoView,
    });
    dispatchAnchorCheckEvent();
    return shouldJump;
  }
  const customizedModules = store.getState()?.projects?.customizedModules;
  const moduleWithoutPageLevelComment = customizedModules
    .filter((i) =>
      [
        DEFALUT_PERMISSION_SECTION.INSIGHT,
        DEFALUT_PERMISSION_SECTION.ANALYSIS,
      ].includes(i.value),
    )
    .flatMap((i) => i.originPermissions)
    .filter((i) => i && moduleKeysWithoutPageLevelComment.includes(i.value))
    .map((i) => i.label)
    .concat('Project Home');
  if (moduleWithoutPageLevelComment.includes(moduleName) && !componentName) {
    // page level comment on Project Home or Analysis
    shouldJump = true;
    targetInfo.actionType = CommentActionType.OpenCommentCenter;
  }

  return shouldJump;
}

// export async function handleLinkFromEmail({
//   history,
//   changeCurrentId,
//   getCustomizedModules,
//   getAccessibleModules,
//   getProjectCompanyInfoId,
// }) {
//   const locationSearchParams = new URLSearchParams(history.location.search);
//   if (locationSearchParams.get('fromEmail') !== 'true') {
//     return;
//   }
//   const projectId = locationSearchParams.get('projectId');
//   if (projectId) {
//     const module = locationSearchParams.get('module');
//     const component = locationSearchParams.get('component');
//     const identifier = locationSearchParams.get('identifier');
//     const channel = Number(locationSearchParams.get('channel'));
//     const channelStatus = JSON.parse(locationSearchParams.get('channelStatus'));
//     const targetInfo = {
//       projectId,
//       moduleName: module,
//       componentName: component === 'null' ? '' : component,
//       identifier: identifier === 'null' ? '' : identifier,
//       channel,
//       channelStatus,
//     };
//
//     const targetModule = urlMap[module];
//     const hasPermission = await beforeJump(targetModule.key, targetInfo);
//     if (hasPermission) {
//       window.SessionStorage.setItem('currentId', projectId);
//       changeCurrentId(projectId);
//       getCustomizedModules(projectId);
//       getAccessibleModules(projectId);
//       getProjectCompanyInfoId(projectId);
//       if (targetModule?.key?.startsWith('analysis/')) {
//         const params = encodeURIComponent(`currentId=${projectId}`);
//         history.replace(`/analysis/${targetModule?.menuId}?${params}`, {
//           menuId: targetModule?.menuId,
//           segmentId: targetModule?.menuId,
//           currentId: projectId,
//         });
//       } else if (targetModule?.key?.startsWith('insights/')) {
//         const params = encodeURIComponent(`currentId=${projectId}`);
//         history.replace(`/insights/${targetModule?.menuId}?${params}`, {
//           menuId: targetModule?.menuId,
//           segmentId: targetModule?.menuId,
//           currentId: projectId,
//         });
//       } else {
//         history.replace(history.location.pathname, {
//           currentId: projectId,
//         });
//       }
//
//       directUser(history, urlMap, targetInfo, () => true, checkUserOnSamePage);
//     } else {
//       history.replace(`/project-detail/${projectId}`, {
//         currentId: projectId,
//       });
//     }
//   }
// }

// TODO: replace this function by exporting same function of common-library
export const isOnShownSource = (thread, accessibleModules) => {
  const { module, component } = thread;
  const identifier = thread.commentIdentifier || thread.identifier;

  const moduleShouldShow =
    Object.keys(accessibleModules).includes(module) ||
    accessibleModules._otherModule?.includes(identifier);

  if (!moduleShouldShow) {
    return false;
  }

  const allowAllComps = accessibleModules[module] === '*';

  if (allowAllComps) {
    return true;
  }

  const isPageLevel = thread.component === '' || thread.component == null;

  return (
    isPageLevel ||
    accessibleModules[module].some(
      (comp) => component.indexOf(comp) !== -1 || comp === identifier,
    )
  );
};
